"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppFavicon = void 0;
const react_1 = require("react");
const dom_util_1 = __importDefault(require("../../util/dom-util"));
const useAppFavicon = (src) => {
    react_1.useEffect(() => {
        if (!src) {
            return;
        }
        dom_util_1.default.changeFavicon(src);
    }, [src]);
    return { change: dom_util_1.default.changeFavicon, getElement: dom_util_1.default.getFavicon };
};
exports.useAppFavicon = useAppFavicon;
exports.default = exports.useAppFavicon;
